<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on }">
      <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
      <v-btn icon v-on="on" color="white">
        <v-icon>fas fa-user-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">Creating New User</v-card-title>
      <v-card-text>
        <v-form ref="AddUserForm">
          <v-text-field
            outlined
            solo
            prepend-inner-icon="fas fa-user-tie"
            v-model.trim="User.FullName"
            validate-on-blur
            :rules="[v => !!v || 'User FullName is required']"
            name="UserFullName"
            label="FUll Name"
            id="idFullName"
          ></v-text-field>
          <v-text-field
            outlined
            solo
            prepend-inner-icon="fas fa-mobile-alt"
            type="number"
            v-model="User.phone"
            validate-on-blur
            :rules="[v => !!v || 'Phone is required']"
            name="UserPhone"
            label="User Phone"
            id="IDusPhone"
          ></v-text-field>
          <v-select
            outlined
            solo
            prepend-inner-icon="fas fa-users-cog"
            v-model="User.UserType"
            :rules="[v => !!v || 'User Group is required']"
            :items="groups"
            item-text="GroupName"
            item-value="GroupName"
            label="User Type"
          ></v-select>
          <v-text-field
            outlined
            solo
            prepend-inner-icon="fas fa-user-cog"
            v-model.trim="User.UserName"
            validate-on-blur
            :rules="[v => !!v || 'User Name is required']"
            name="UserName"
            label="Login Name"
            id="LoginID"
          ></v-text-field>
          <v-text-field
            outlined
            solo
            prepend-inner-icon="fas fa-key"
            v-model="User.pasword1"
            validate-on-blur
            :rules="[requiredFild, lengthPass]"
            name="namePass1"
            label="New Password"
            id="idPass1"
          ></v-text-field>
          <v-text-field
            outlined
            solo
            prepend-inner-icon="fas fa-key"
            v-model="User.pasword2"
            :rules="[MutchPassword]"
            name="namePass2"
            label="Confirm"
            id="idPass2"
          ></v-text-field>
        </v-form>
        <p
          v-if="ErrMessage"
          v-html="ErrMessage"
          class="error text-center white--text"
        ></p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" :disabled="clicked" text @click="close"
          >Cancel</v-btn
        >
        <v-btn color="green darken-1" :loading="clicked" text @click="OnAddUser"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: { AtFinshed: { type: Function } },
  data() {
    return {
      ErrMessage: "",
      clicked: false,
      dialog: false,
      groups: [],
      User: {
        FullName: "",
        phone: "",
        UserType: "",
        UserName: "",
        pasword1: "",
        pasword2: "",
      },
    };
  },
  methods: {
    GoupLoad() {
      this.$store
        .dispatch("GET_ONLY", "/users/groups")
        .then(result => {
          this.groups = result.data;
          // console.log(result);
        })
        .catch(() => {
          // console.log(error);
        });
    },
    OnAddUser() {
      this.ErrMessage = "";
      if (this.$refs.AddUserForm.validate()) {
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/users/abur",
            data: {
              LoginUser: this.User,
            },
          })
          .then(() => {
            this.clicked = false;
            // console.log(value);
            this.AtFinshed();
            this.close();
          })
          .catch(error => {
            this.clicked = false;
            // console.log(error && error.response && error.response.data);
            // console.log(error.response);
            /* if (error.response) */ this.ErrMessage =
              error && error.response && error.response.data;
          });
      }
    },
    close() {
      this.dialog = false;
      //   this.User.phone = "";
      this.$refs.AddUserForm.reset();
    },
    requiredFild(v) {
      if (!v) return "this is required";
      else return true;
    },
    MutchPassword(v) {
      if (this.User.pasword1 != v) return "passwords in not match";
      else return true;
    },
    lengthPass(v) {
      if (v && v.length < 6) return "Min length is 6";
      else return true;
    },
  },
  mounted() {
    this.GoupLoad();
  },
};
</script>
